import React from 'react';
import { UnifiedMessage } from '../../types/whatsapp';
import { ChannelBadge } from './ChannelBadge';
import { CheckIcon, CheckCheckIcon, PlayIcon, FileTextIcon } from 'lucide-react';
interface MessageItemProps {
  message: UnifiedMessage;
}
export function MessageItem({
  message
}: MessageItemProps) {
  const isDealer = message.from === 'dealer' || message.from === 'bot';
  const isSystem = message.from === 'system';
  if (isSystem) {
    return <div className="flex justify-center my-4" data-id="element-455">
        <span className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full" data-id="element-456">
          {message.content} • {message.timestamp}
        </span>
      </div>;
  }
  return <div className={`flex ${isDealer ? 'justify-end' : 'justify-start'} mb-4 group`} data-id="element-457">
      <div className={`max-w-[75%] ${isDealer ? 'items-end' : 'items-start'} flex flex-col`} data-id="element-458">
        <div className="flex items-center space-x-2 mb-1 px-1" data-id="element-459">
          <span className="text-xs text-gray-500" data-id="element-460">
            {message.from === 'bot' ? 'Automated' : message.timestamp}
          </span>
          <ChannelBadge channel={message.channel} size="sm" data-id="element-461" />
        </div>

        <div className={`px-4 py-3 rounded-2xl shadow-sm relative ${message.channel === 'whatsapp' && isDealer ? 'bg-[#d9fdd3] text-gray-900 rounded-tr-none' : message.channel === 'sms' && isDealer ? 'bg-purple-100 text-gray-900 rounded-tr-none' : message.channel === 'email' && isDealer ? 'bg-orange-50 text-gray-900 border border-orange-100 rounded-tr-none' : message.channel === 'voice' ? 'bg-blue-50 border border-blue-100 text-gray-900' : message.from === 'bot' ? 'bg-gray-100 text-gray-800 rounded-tr-none' : 'bg-white text-gray-900 border border-gray-100 rounded-tl-none'}`} data-id="element-462">
          {/* Content based on type */}
          {message.type === 'call' ? <div className="flex items-center space-x-3 min-w-[200px]" data-id="element-463">
              <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white" data-id="element-464">
                <PlayIcon size={14} fill="currentColor" data-id="element-465" />
              </div>
              <div data-id="element-466">
                <p className="text-sm font-medium" data-id="element-467">
                  Voice Call • {message.metadata?.callDuration}
                </p>
                <p className="text-xs text-gray-500" data-id="element-468">
                  {message.status === 'missed' ? 'Missed Call' : 'Recording Available'}
                </p>
              </div>
            </div> : message.type === 'document' ? <div className="flex items-center space-x-3 bg-white/50 p-2 rounded-lg" data-id="element-469">
              <FileTextIcon size={24} className="text-red-500" data-id="element-470" />
              <div data-id="element-471">
                <p className="text-sm font-medium" data-id="element-472">Brochure.pdf</p>
                <p className="text-xs text-gray-500" data-id="element-473">1.2 MB</p>
              </div>
            </div> : <p className="text-sm whitespace-pre-wrap leading-relaxed" data-id="element-474">
              {message.content}
            </p>}

          {/* Status Indicator */}
          {isDealer && message.type !== 'call' && <div className="absolute bottom-1 right-2" data-id="element-475">
              {message.status === 'read' ? <CheckCheckIcon size={14} className="text-blue-500" data-id="element-476" /> : <CheckIcon size={14} className="text-gray-400" data-id="element-477" />}
            </div>}
        </div>
      </div>
    </div>;
}